import { Avatar, Card, CardContent, CardHeader, Typography } from '@mui/material'
import Rating from '@mui/material/Rating';
import React from 'react'
import "react-glidejs/dist/index.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import girl1 from '../assets/girl1.png';
import girl2 from '../assets/girl2.png';
import girl3 from '../assets/girl3.png';
import girl4 from '../assets/girl4.png';
import girl5 from '../assets/girl5.png';
import boy1 from '../assets/boy1.png';
import boy2 from '../assets/boy2.png';
import boy3 from '../assets/boy3.png';
function useMobileDetect() {
    const [isMobile, setIsMobile] = React.useState(false);
    SwiperCore.use([Navigation]);

    React.useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 768);
        }

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    return isMobile;
}
function Avis() {

    const isMobile = useMobileDetect();
    const reviews = [
        { name: "현수", avatar: boy1, rating: 4.5, review: "이 음식은 정말 맛있었습니다! 이 가게에서 저녁을 먹었을 때, 이 요리는 분명히 하이라이트였습니다. 이 음식에는 따뜻한 풍미가 가득하고, 양념은 완벽했습니다. 다시 방문할 것입니다. 😍" },
        { name: "애차", avatar: girl2, rating: 5, review: "저는 이 요리를 정말로 즐겼습니다. 요리가 고급스럽게 제공되었고, 맛이 풍부했습니다. 특히 이 요리의 질감이 좋았습니다. 모든 식사가 이렇게 만족스러웠으면 좋겠습니다! 💌" },
        { name: "다에", avatar: girl1, rating: 4, review: "이것은 저의 최애 음식입니다! 이 음식은 항상 제 기대를 초과합니다. 그것은 항상 신선하며, 그 맛은 뛰어납니다. 이 가게의 직원들은 항상 친절하고, 음식이 빠르게 제공됩니다. 💕 " },
        { name: "영희", avatar: girl3, rating: 4.5, review: "이 가게의 음식은 절대로 실망시키지 않습니다. 맛, 향, 질감, 모든 것이 완벽합니다. 내가 이곳에 오는 것을 사랑하고, 누구에게나 추천할 것입니다. 👌" },
        { name: "준희", avatar: boy2, rating: 5, review: "이 음식은 창의적이고 독특합니다. 나는 여기에 오는 것을 즐기고, 매번 새로운 것을 시도하는 것을 좋아합니다. 직원들은 항상 친절하고 도움이 됩니다. 😃" },
        { name: "미나", avatar: girl4, rating: 5, review: "이곳의 음식은 절대로 실망하지 않습니다. 나는 항상 그들의 신선한 재료와 멋진 조리법에 감탄하고 있습니다. 또한 서비스는 항상 훌륭합니다! 👏" },
        { name: "진수", avatar: boy3, rating: 4.5, review: "나는 이곳의 요리를 사랑합니다! 그들의 메뉴는 항상 신선하고, 그들의 음식은 맛있습니다. 나는 특히 그들의 양념에 대한 사랑이 큽니다. 👍" },
        { name: "지현", avatar: girl5, rating: 4, review: "나는 이 가게를 좋아합니다! 음식은 맛있고, 분위기는 편안합니다. 나는 이곳에서 여러 번 식사를 했고, 항상 매우 만족스럽습니다. 놀라운 음식과 서비스를 위해 감사합니다! 🌟" },
    ]

    return (
        <div>
            <Typography sx={{ fontFamily: 'Gowun Batang', fontWeight: '700' }} align='center' mt={4} mb={5} variant='h2' >의견</Typography>
            <div className='card-container' style={{ marginBottom: '70px' }} >

                <Swiper

                    slidesPerView={isMobile ? 1 : 3}
                    modules={[Navigation]}
                    spaceBetween={10}
                    centeredSlides={true}
                    loop={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    navigation
                    className="mySwiper">
                    {reviews.map((review, index) => (
                        <SwiperSlide key={index}>
                            <Card sx={{ maxWidth: "750px", minHeight: "300px", backgroundColor: 'rgba(245, 245, 245, 0.8)', boxShadow: 2, margin: '10px' }}>
                                <CardContent>
                                    <CardHeader title={
                                        <Typography sx={{ fontFamily: 'Gowun Batang' }} variant="h4" >{review.name}</Typography>
                                    } avatar={<Avatar sx={{ width: '80px', height: '80px' }} src={review.avatar} />} action={
                                        <Rating name="read-only" value={review.rating} readOnly />
                                    } />
                                    <Typography sx={{ fontFamily: 'Gamja Flower', fontSize: '20px' }} paragraph>{review.review}</Typography>
                                </CardContent>
                            </Card>
                        </SwiperSlide>
                    ))}
                </Swiper>

            </div>
        </div >
    )
}

export default Avis